// frontend/src/paginas/tienda_publica/orden_resumen/components/AmbientBackground.jsx
import React from 'react';

const AmbientBackground = () => (
  <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none bg-[#020202]">
    <div className="absolute top-[-10%] right-[20%] w-[60vw] h-[60vw] bg-emerald-900/20 rounded-full blur-[60px] opacity-30 mix-blend-screen" />
    <div className="absolute bottom-[10%] left-[10%] w-[50vw] h-[50vw] bg-indigo-900/10 rounded-full blur-[60px] opacity-20 mix-blend-screen" />
  </div>
);

export default AmbientBackground;